import { NgModule } from '@angular/core';
import { SubscriptionRoutingModule } from './subscription-routing.module';
import { SubscriptionComponent } from './subscription.component';
import { PersonalizeComponent } from './personalize/personalize.component';
import { AccountCreationComponent } from './account-creation/account-creation.component';
import { PaymentComponent } from './payment/payment.component';
import { SharedComponentModule } from '../sharedComponent/register-content/sharedComponent.module';
import { MainComponentModule } from '../sharedComponent/main-component/mainComponent.module';
import { MatStepperModule } from '@angular/material/stepper';
import { ProcessingPaymentDialogComponent } from './process-payment-dialog/process-payment-dialog.component';
import { ProceedPaymentComponent } from './payment/proceed-payment/proceed-payment.component';
import { DialogItemSizeComponent } from './dialog-item-size/dialog-item-size.component';
import { NetworkCheckComponent } from './network-check/network-check.component';
import { DialogConversionComponent } from 'app/dialog/dialog-conversion/dialog-conversion.component';

const subscriptionComponents = [
    SubscriptionComponent,
    NetworkCheckComponent,
    PersonalizeComponent,
    AccountCreationComponent,
    PaymentComponent,
    ProceedPaymentComponent,
    ProcessingPaymentDialogComponent,
    DialogItemSizeComponent,
    DialogConversionComponent
];

const angularMaterialModules = [
    MatStepperModule,
];

@NgModule({
    imports: [
        MainComponentModule,
        SharedComponentModule,
        SubscriptionRoutingModule,
        angularMaterialModules
    ],
    declarations: [
        subscriptionComponents,
    ]
})
export class SubscriptionModule { }
